<script>
  import Card from '../Components/Card.svelte';
  import { fly } from 'svelte/transition';
  import Paths from '../Utils/Paths.svelte';

  var root = document.documentElement;
  const lists = document.querySelectorAll('.hs');

  // lists.forEach((el) => {
  //   const listItems = el.querySelectorAll('li');
  //   const n = el.children.length;
  //   el.style.setProperty('--total', n);
  // });
</script>

<div class="asdesk">
  <div class="">
    <div class="">
      <div class="grid grid-cols-3 gap-11">
        <div in:fly="{{ delay: 200, x: 100, duration: 1500 }}">
          <Card id="1" />
          <Paths namestore="nomTrappe" />
        </div>
        <div in:fly="{{ delay: 400, x: 100, duration: 1500 }}">
          <Card id="2" />
        </div>
        <div in:fly="{{ delay: 600, x: 100, duration: 1500 }}">
          <Card id="3" />
        </div>
        <div in:fly="{{ delay: 800, x: 100, duration: 1500 }}">
          <Card id="4" />
        </div>
        <div in:fly="{{ delay: 1000, x: 100, duration: 1500 }}">
          <Card id="5" />
        </div>
        <!-- <div in:fly="{{delay: 1200, x: 100, duration: 1500 }}">
            <Card id="" />
        </div> -->
      </div>
    </div>
  </div>
</div>

<div class="asphone">
  <div class="app">
    <ul class="hs full" style="--total: 5">
      <li class="item"><Card id="1" /></li>
      <li class="item"><Card id="2" /></li>
      <li class="item"><Card id="3" /></li>
      <li class="item"><Card id="4" /></li>
      <li class="item"><Card id="5" /></li>
    </ul>
  </div>
</div>

<style>
  :root {
    --gutter: 45px;
  }

  .app {
    padding: var(--gutter) 0;
    display: grid;
    grid-gap: var(--gutter) 0;
    grid-template-columns: var(--gutter) 1fr var(--gutter);
    align-content: start;
    overflow-y: scroll;
  }

  .app > * {
    grid-column: 2 / -2;
  }

  .app > .full {
    grid-column: 1 / -1;
  }

  .hs {
    display: grid;
    grid-gap: calc(var(--gutter) / 2);
    /* grid-template-columns:
      10px repeat(var(--total), calc(50% - var(--gutter) * 2))
      10px; */
    grid-template-columns: 0 repeat(var(--total), 220px) 0;
    grid-template-rows: minmax(250px, 1fr);
    overflow-x: scroll;
    scroll-snap-type: x proximity;
  }

  .hs:before,
  .hs:after {
    content: '';
  }

  .hs > li,
  .item {
    /* min-width: 300px; */
    /* scroll-snap-align: center;
    padding: calc(var(--gutter) / 2 * 1.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    background: #fff;
    border-radius: 8px; */
  }
</style>
